export default __webpack_public_path__ + "static/makers-place-b3d5b4bab1efe9593938c1be48d2cc91.png";